import { Access } from '../contexts/user';

type ReportsUser = {
  wpAdmin?: boolean;
  organization?: { id?: string; access?: Access };
} | null | undefined;

export function canAccessOrgReports(user: ReportsUser): boolean {
  if (!user?.organization?.id || user.wpAdmin) {
    return false;
  }
  if (!user.organization.access) {
    return false;
  }
  return [Access.ADMIN, Access.MANAGER, Access.OWNER].includes(user.organization.access);
}

export function canAccessReports(user: ReportsUser): boolean {
  return !!user?.wpAdmin || canAccessOrgReports(user);
}
